/**
 * memo カードの判定欄の文言（card-schema.md §3.9）。正誤は src/lib/cards の gradeMemo が決める。
 */
import { gradeMemo, type MemoAnswer, type MemoCard } from '../../lib/cards';
import type { GradeResult } from '../types';

const AGAIN = 'このカードはあとでもう一度出ます。';

export function memoGradeResult(card: Pick<MemoCard, 'recall'>, answer: MemoAnswer): GradeResult {
  const ok = gradeMemo(card, answer) === 'correct';
  switch (answer.kind) {
    case 'self-report':
      return ok
        ? { verdict: 'AC', message: '思い出せたものとして記録しました。' }
        : { verdict: 'WA', message: `思い出せなかったものとして記録しました。${AGAIN}` };
    case 'typed':
      return ok
        ? { verdict: 'AC', message: '答えと一致しました。' }
        : { verdict: 'WA', message: `答えと一致しませんでした。${AGAIN}` };
    case 'revealed':
      return { verdict: 'WA', message: `答えを見てから進みます。${AGAIN}` };
  }
}
